import { Button } from "@mui/material";
import { Link } from "gatsby";
import React, { useContext } from "react";
import { SearchFormContext } from "../search-form-core";
import { useFormContext } from "react-hook-form";

export const SearchResultsButton = () => {
    const { results, loading, onFormSubmit } = useContext(SearchFormContext);
    const methods = useFormContext();
    return (
        <Button
            variant="contained"
            disabled={results.length === 0}
            className="w-full bg-sh-red md:max-w-[320px]"
            onClick={() => {
                methods.handleSubmit(onFormSubmit)();
            }}
        >
            <div className="flex flex-col gap-0 py-1 leading-[20px]">
                <span className="ml-[3px] font-bold tracking-[4px]">
                    FIND HOLIDAY
                </span>
                {loading ? (
                    <span>Loading...</span>
                ) : (
                    <span className="normal-case">
                        -{"> "}
                        {`${results.length} `}destinations
                    </span>
                )}
            </div>
        </Button>
    );
};
